import Alert from 'sweetalert2';
import './style.scss';

export default Alert;
